'use strict'

const SELECTOR = '.js-pds-micro-video';
const HEADER_SELECTOR = '.js-mega-nav';
const MOBILE_SLIDER = '.js-scrolling-area .js-scrolling-area__area';
const MOBILE_SLIDER_ITEM_ACTIVE = '.js-scrolling-area__item.is-active';
const mediaDesktop = '(min-width: 768px)';
const EVENT_NAME = 'deu__pdp_microvideo-view';
let headerHeight = 0;

export function init() {
    const productMicroVideos = document.querySelectorAll(SELECTOR);
    if (!productMicroVideos.length) return;
    const mobileSlider = document.querySelector(MOBILE_SLIDER);
    if (!mobileSlider) {
        console.warn('1715072069 - pdsMicroVideo.js: mobileSlider element missing, mobile tracking not possible');
        return;
    }

    let header = document.querySelector(HEADER_SELECTOR);
    headerHeight = header ? header.getBoundingClientRect().height : 0;

    window.addEventListener('resize', evt => {
        header = document.querySelector(HEADER_SELECTOR);
        headerHeight = header ? header.getBoundingClientRect().height : 0;
    });

    window.dataLayer = window.dataLayer ?? [];
    const playedProductMicroVideos = [];
    Array.from(productMicroVideos).forEach(productMicroVideo => {
        if (window.matchMedia(mediaDesktop).matches) {
            document.addEventListener('DOMContentLoaded', evt => {
                if (checkIfMicroVideoIsInViewport(productMicroVideo) && !playedProductMicroVideos.includes(productMicroVideo)) {
                    window.dataLayer.push({event: EVENT_NAME});
                    playedProductMicroVideos.push(productMicroVideo);
                }
            });
            window.addEventListener('scroll', evt => {
                if (checkIfMicroVideoIsInViewport(productMicroVideo) && !playedProductMicroVideos.includes(productMicroVideo)) {
                    window.dataLayer.push({event: EVENT_NAME});
                    playedProductMicroVideos.push(productMicroVideo);
                }
            });
        } else {
            mobileSlider.addEventListener('scroll', evt => {
                // use setTimeout in order to circumvent slider adding of "is-active" class
                setTimeout(() => {
                    if (productMicroVideo.closest(MOBILE_SLIDER_ITEM_ACTIVE) && !playedProductMicroVideos.includes(productMicroVideo)) {
                        window.dataLayer.push({event: EVENT_NAME});
                        playedProductMicroVideos.push(productMicroVideo);
                    }
                }, 100)
            })
        }
    })
}

function checkIfMicroVideoIsInViewport(productMicroVideo) {
    return productMicroVideo.getBoundingClientRect().y >= headerHeight;
}